import { SHA256 } from 'crypto-js';

export function generateHash(valueString: string): string {
  const dateSalt = new Date().toISOString().split('T')[0];
  const stringToEncode = `${valueString}${dateSalt}`;
  return SHA256(stringToEncode).toString().slice(0, -5);
}
